export default {
  'app.network.offline': '當前處於離線狀態，部分功能可能不可用',
  'app.error.chunk.title': '頁面載入失敗',
  'app.error.chunk.description.offline':
    '網路連線已中斷，請檢查網路後重新整理頁面。',
  'app.error.chunk.description.online':
    '頁面資源載入失敗，請重新整理頁面重試。',
  'app.error.render.title': '頁面出現錯誤',
  'app.error.render.description':
    '抱歉，頁面遇到了一些問題，請重新整理頁面或返回首頁。',
  'app.error.retry': '重試',
  'app.error.reload': '重新整理頁面',
  'app.error.home': '返回首頁',
  'app.request.offline': '網路不可用，請檢查網路連線後重試。',
};
